module.exports = __webpack_public_path__ + "img/arrow-up-left.4c789533.svg";